/*global define*/

define("collections/Tool", [
    'underscore',
    'backbone',
    'models/Tool'
], function (_, Backbone, ToolModel) {
    'use strict';

    var ToolCollection = Backbone.Collection.extend({
        model: ToolModel
    });

    return ToolCollection;
});
